module.exports = __webpack_public_path__ + "static/media/cover-image-asda.9876fba9.jpg";